<template>
  <div :class="giftRowGroupCssClass" v-if="areGiftsValid">
    <div v-if="!this.enableMinicartPicker">
      <div :class="`${prefilledStylingOptions.groupRow}`">
        <div :class="`${prefilledStylingOptions.groupBlock}`" v-if="shouldShowDescription">
          <div :class="`${prefilledStylingOptions.groupBlockRow}`">
            <div :class="`${imageCssClass}`">
              <img :class="`${prefilledStylingOptions.groupBlockThumbnail}`"
                   v-if="cartGiftProductGroup.image"
                   :src="getGiftImageSource"
                   @error="imageHasErrors = true"
                   :alt="cartGiftProductGroup.description">
            </div>
            <div :class="`${descriptionCssClass}`">
              {{ cartGiftProductGroup.description }}
            </div>
            <div :class="`${prefilledStylingOptions.hint} ${selectionStatus.selectionClass}`"
                 v-if="shouldEnablePicker(cartGiftProductGroup.id)">
              <div :class="`${prefilledStylingOptions.hintRow}`">
                <div :class="`${prefilledStylingOptions.hintRowMessage}`">
                  {{ t('modal.gift_rule.hint', { namespace: 'giftSelection', params: [cartGiftProductGroup] }) }}
                </div>
                <div :class="`${prefilledStylingOptions.hintRowCounter}`">
                  ({{ summarizeSelectionCount }}/{{cartGiftProductGroup.gift_user_choice_count}})
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :class="`${prefilledStylingOptions.itemsBlock}`">
          <div v-if="!shouldEnablePicker(cartGiftProductGroup.id) && !shouldEnableMinicartPicker(cartGiftProductGroup.id) && !isMiniCartComponent" class="advCartGiftRowV2">
            <adv-cart-gift-row-v2
              v-for="(productId, index) in getGiftProductChoices"
              :key="index"
              :mini-cart="miniCart"
              :is-mini-cart-component="isMiniCartComponent"
              :enable-picker="shouldEnablePicker(cartGiftProductGroup.id)"
              :enable-minicart-picker="shouldEnableMinicartPicker(cartGiftProductGroup.id)"
              :styling-options="stylingOptions"
              :gift-data="cartGiftProductGroup"
              :cart-product="resolveCartProduct(productId)"></adv-cart-gift-row-v2>
          </div>
          <div v-else :class="`${prefilledStylingOptions.itemsBlockRow}`">
            <adv-cart-gift-row
              v-for="(productId, index) in getGiftProductChoices"
              :key="index"
              :mini-cart="miniCart"
              :is-mini-cart-component="isMiniCartComponent"
              :enable-picker="shouldEnablePicker(cartGiftProductGroup.id)"
              :enable-minicart-picker="shouldEnableMinicartPicker(cartGiftProductGroup.id)"
              :styling-options="stylingOptions"
              :gift-data="cartGiftProductGroup"
              :cart-product="resolveCartProduct(productId)"></adv-cart-gift-row>
          </div>
        </div>
      </div>
    </div>
    <div :class="`${prefilledStylingOptions.giftBlock}`" v-else>
      <div :class="`${prefilledStylingOptions.groupRowMlr}`">
        <div :class="`${prefilledStylingOptions.giftChoiceContent}`">
          <div :class="`${prefilledStylingOptions.groupRowMlr}`">
            <div :class="`${prefilledStylingOptions.pickYourGift}`">
              <span>{{ t('modal.gift_rule_in_box.hint', { namespace: 'giftSelection', params: [cartGiftProductGroup] }) }}</span>
            </div>
            <div :class="giftIconCssClass" @click="modalPopUp">
              <div v-html="minicartSelectionStatus.selectionClass" :class="`${prefilledStylingOptions.miniCartGiftSelectionStatus}`"></div>
              <div class="thumbnail_container">
                <div class="thumbnail">
                  <img :src="giftMinicartImage" class="img-responsive" alt="gift_icon">
                </div>
              </div>
            </div>
            <div :class="`${prefilledStylingOptions.giftRuleDescription}`">
              <!-- Trim in minicart -->
              <span>{{cartGiftProductGroup.description}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { get, isEmpty, map, filter } from 'lodash-es'
import { mapGetters } from 'vuex'
import AdvCartGiftRow from './AdvCartGiftRow'
import AdvCartGiftRowV2 from '../../main/vue/AdvCartGiftRowV2'
import cartGiftOptionsMixin from './mixins/cartGiftOptionsMixin'
import store from '../../vue/store'
import giftSelectionMixin from './mixins/giftSelectionMixin'
export default {
  name: 'AdvCartGiftRowGroup',
  components: { AdvCartGiftRow, AdvCartGiftRowV2 },
  mixins: [giftSelectionMixin, cartGiftOptionsMixin],
  props: {
    cartGiftProductGroup: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      imageHasErrors: false
    }
  },
  mounted () {
    this.getGiftSelectionFromLocalStorage()
  },
  computed: {
    ...mapGetters(['getSelectedGifts']),
    getGiftProductChoices: function () {
      const productsRequirementOptionType = 1
      return this.cartGiftProductGroup.choices[productsRequirementOptionType]
    },
    getGiftImageSource: function () {
      const resourceImage = this.cartGiftProductGroup.image
      return `/files/gifts/${resourceImage}`
    },
    summarizeSelectionCount: function () {
      const selectedGiftsForThisGiftId = get(this.getSelectedGifts, this.cartGiftProductGroup.id)
      return isEmpty(selectedGiftsForThisGiftId) ? 0 : Number(Object.keys(selectedGiftsForThisGiftId).length)
    },
    selectionStatus: function () {
      const success = {
        selectionClass: 'gift-select-success gift-select-opt gift-selected'
      }
      const failure = {
        selectionClass: 'gift-select-error gift-select-opt gift-not-selected'
      }
      return (this.summarizeSelectionCount === Number(this.cartGiftProductGroup.gift_user_choice_count))
        ? success : failure
    },
    minicartSelectionStatus () {
      const success = {
        selectionClass: '<i class="fa fa-check-circle"></i>'
      }
      const failure = {
        selectionClass: '<i class="fa fa-plus-circle"></i>'
      }
      return (this.summarizeSelectionCount === Number(this.cartGiftProductGroup.gift_user_choice_count))
        ? success : failure
    },
    areGiftsValid () {
      const cartGiftProducts = map(this.getGiftProductChoices, (giftProductId) => {
        return this.resolveCartProduct(giftProductId)
      })
      const unresolvedCartProduct = filter(cartGiftProducts, (cartGiftProduct) => {
        return isEmpty(cartGiftProduct)
      })
      return !(unresolvedCartProduct.length > 0)
    },
    hasImage () {
      return !isEmpty(this.cartGiftProductGroup.image) && !this.imageHasErrors
    },
    hasDescription () {
      return !isEmpty(this.cartGiftProductGroup.description)
    },
    shouldShowDescription () {
      return this.hasDescription && this.shouldEnablePicker(this.cartGiftProductGroup.id)
    },
    imageCssClass () {
      return (this.hasImage)
        ? this.prefilledStylingOptions.groupBlockThumbnailBlock
        : this.prefilledStylingOptions.groupBlockThumbnailBlockNoImage
    },
    descriptionCssClass () {
      return (this.hasImage)
        ? this.prefilledStylingOptions.groupBlockDescription
        : this.prefilledStylingOptions.groupBlockDescriptionNoImage
    },
    giftIconCssClass () {
      if (!this.isMiniCartComponent) {
        return (this.giftSelectionNotEmpty)
          ? `${this.prefilledStylingOptions.giftIconBg}` + ' col-md-1'
          : `${this.prefilledStylingOptions.giftIconBg}` + ' col-md-1 animate'
      }
      return (this.giftSelectionNotEmpty)
        ? `${this.prefilledStylingOptions.giftIconBg}`
        : `${this.prefilledStylingOptions.giftIconBg}` + ' animate'
    },
    giftMinicartImage () {
      return (this.giftSelectionNotEmpty)
        ? '/ui/main/img/gift_default_3.svg'
        : '/ui/main/img/gift_default_2.svg'
    },
    giftSelectionNotEmpty () {
      return this.getSelectedGifts[this.cartGiftProductGroup.id] && Object.keys(this.getSelectedGifts).length !== 0
    },
    giftRowGroupCssClass () {
      return this.enableMinicartPicker
        ? `${this.prefilledStylingOptions.group}` + ' advGiftRowGroup p-0'
        : `${this.prefilledStylingOptions.group}` + ' advGiftRowGroup'
    }
  },
  methods: {
    resolveCartProduct (productId) {
      return this.$store.getters.findCartProductFromProductIdAndGift({ productId: productId })
    },
    modalPopUp () {
      store.dispatch('popupMinicartGiftModal', true)
    }
  }
}
</script>
